import {useQuery} from "@tanstack/react-query"
import {generalSettingsService} from "services"
import {YesNo} from "types/common"
import {GeneralSettingField} from "types/settings/general-setting"

type UseGradingSystemSettingProps = {
    enabled?: boolean
}

export enum FameGradeExportPracticalType {
    Individual = "individual",
    ModulePercentage = "module_percentage",
    SubmodulePercentage = "submodule_percentage"
}

export enum GradingType {
    ClassActivityHighestGrade = "class_activity_highest_grade",
    BasedOnGradingSystem = "based_on_grading_system"
}

const useGradingSystemSetting = (props?: UseGradingSystemSettingProps) => {
    const {enabled = true} = props || {}
    const {data, refetch, isFetching} = useQuery(
        ["grading-system-setting"],
        () =>
            generalSettingsService.getSettings([
                GeneralSettingField.FameGradeExportCourseGrades,
                GeneralSettingField.FameGradeExportClassActivities,
                GeneralSettingField.FameGradeExportPractical,
                GeneralSettingField.FameGradeExportPracticalType,
                GeneralSettingField.GradingType
            ]),
        {
            initialData: [],
            enabled
        }
    )

    const isSettingEnabled = (fieldName: GeneralSettingField) =>
        data.find((setting) => setting.field === fieldName)?.value === YesNo.Yes

    const getSettingValue = (fieldName: GeneralSettingField) =>
        data.find((setting) => setting.field === fieldName)?.value

    return {
        data,
        isCheckedFameGradeExportCourseGrades: isSettingEnabled(GeneralSettingField.FameGradeExportCourseGrades),
        isCheckedFameGradeExportClassActivities: isSettingEnabled(GeneralSettingField.FameGradeExportClassActivities),
        isCheckedFameGradeExportPractical: isSettingEnabled(GeneralSettingField.FameGradeExportPractical),
        fameGradeExportPracticalType: getSettingValue(
            GeneralSettingField.FameGradeExportPracticalType
        ) as FameGradeExportPracticalType,
        gradingType: getSettingValue(GeneralSettingField.GradingType) as GradingType,
        refetch,
        isFetching
    }
}

export {useGradingSystemSetting}
